"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var searchroute_service_1 = require("./../../../Services/searchroute.service");
var seo_service_1 = require("./../../../Services/seo.service");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var geolocation_service_1 = require("./../../../Services/geolocation.service");
var service_service_1 = require("src/app/Services/service.service");
var forms_1 = require("@angular/forms");
var router_1 = require("@angular/router");
var search_small_component_1 = require("./../../../Adv/search-small/search-small.component");
var SearchComponent = /** @class */ (function (_super) {
    __extends(SearchComponent, _super);
    function SearchComponent(router, fb, service, geolocationService, cookieService, seo, searchRouteService) {
        var _this = _super.call(this, router, fb, service, geolocationService, cookieService, seo, searchRouteService) || this;
        service.pageName = "Search";
        return _this;
    }
    SearchComponent.prototype.selectOpenChange = function (isOpen, matSelect) {
        var backdropOverlay = matSelect.overlayDir._overlay._overlayContainer._containerElement;
        var backdropOverlayHeight = backdropOverlay.offsetHeight;
        var optionsLength = matSelect.options.length;
        if (isOpen) {
            if (optionsLength < 2) {
                backdropOverlay.classList.add("emptyOptions");
            }
            else {
                backdropOverlay.classList.remove("emptyOptions");
            }
            backdropOverlay.classList.add("customBackdropOverlay");
            if (backdropOverlayHeight < 250) {
                backdropOverlay.classList.add("customBackdropOverlay250");
            }
            else if (backdropOverlayHeight < 350) {
                backdropOverlay.classList.add("customBackdropOverlay350");
            }
            else if (backdropOverlayHeight < 450) {
                backdropOverlay.classList.add("customBackdropOverlay450");
            }
        }
    };
    Object.defineProperty(SearchComponent.prototype, "keywords", {
        get: function () { return this.advSearchForm.get('keywords'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(SearchComponent.prototype, "zipCode", {
        get: function () { return this.advSearchForm.get('zipCode'); },
        enumerable: true,
        configurable: true
    });
    ;
    SearchComponent.prototype.getRouterUrl = function () { return _super.prototype.getRouter.call(this).url; };
    ;
    SearchComponent.prototype.resetKeywords = function () {
        this.advSearchForm.patchValue({ keywords: '' });
    };
    SearchComponent.prototype.resetZip = function () {
        this.advSearchForm.patchValue({ zipCode: '' });
    };
    return SearchComponent;
}(search_small_component_1.SearchSmallComponent));
exports.SearchComponent = SearchComponent;
